import {
    DashboardOutlined,
    UserOutlined,
    DotChartOutlined,
    ExclamationCircleOutlined,
    CarOutlined,
    QuestionCircleOutlined,
    RadiusSettingOutlined,
    BarsOutlined
} from '@ant-design/icons';
import { APP_PREFIX_PATH } from 'configs/AppConfig'

const dashBoardNavTree = [
    {
      key: 'home',
      path: `${APP_PREFIX_PATH}/`,
      title: 'home',
      icon: DashboardOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
        key: 'questions',
        path: `${APP_PREFIX_PATH}/questions`,
        title: 'questions',
        icon: QuestionCircleOutlined,
        breadcrumb: false,
        submenu: []
    },
    {
        key: 'response',
        path: `${APP_PREFIX_PATH}/response`,
        title: 'response',
        icon: DotChartOutlined,
        breadcrumb: false,
        submenu: []
    },
    {
        key: 'routes',
        path: `${APP_PREFIX_PATH}/routes`,
        title: 'routes',
        icon: RadiusSettingOutlined,
        breadcrumb: false,
        submenu: []
    },
    {
        key: 'vehicles',
        path: `${APP_PREFIX_PATH}/vehicles`,
        title: 'vehicles',
        icon: CarOutlined,
        breadcrumb: false,
        submenu: []
    },
    {
        key: 'purposes',
        path: `${APP_PREFIX_PATH}/purposes`,
        title: 'purposes',
        icon: BarsOutlined,
        breadcrumb: false,
        submenu: []
    },
    {
        key: 'reports',
        path: `${APP_PREFIX_PATH}/reports`,
        title: 'reports',
        icon: ExclamationCircleOutlined,
        breadcrumb: false,
        submenu: []
    },
    {
      key: 'users',
      path: `${APP_PREFIX_PATH}/users`,
      title: 'users',
      icon: UserOutlined,
      breadcrumb: false,
      submenu: []
    }
]

const navigationConfig = [
  ...dashBoardNavTree
]

export default navigationConfig;
